var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConservativeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_8508",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8597"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6108",
    d: "M16,0A16,16,0,1,1,0,16,16,16,0,0,1,16,0Z",
    fill: "#9f9f9f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4991",
    d: "M3270,334.785v9.19",
    transform: "translate(-3254 -321.703)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4993",
    d: "M3270,331.817v6.652",
    transform: "translate(-3258.75 -316.41)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4992",
    d: "M3270,331.817v11.64",
    transform: "translate(-3249.25 -320.949)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConservativeIcon);
export default __webpack_public_path__ + "static/media/conservative_icon.e50408ba177bb6a6068bf4f8e581edb8.svg";
export { ForwardRef as ReactComponent };